import { HttpProvider } from "../http/http.provider";

import { addProvider, IProviderDescriptor, ServiceEndpointConstants } from "../ServiceUtil";
import { Observable } from "rxjs";
import { share, map } from "rxjs/operators";

import { createFormData } from "../util/utilities";
import { ITimeCard, ITimeSheet, ITimeSheetRequestData, ITimeSheetResponse } from "./invoice.interface";
import { IHttpRequestConfig } from "../http/types/http.types";
import { TimesheetTransformer } from "./timesheet.transformer";
import { ITimesheetInternal } from "./timesheet.dto";


export class InvoiceDelegate
{
    constructor(private http: HttpProvider) { }


    public createNewEmployeeTimeCard(newtimecard: ITimeCard): Observable<any>
    {

        const formdata = createFormData(newtimecard);

        return this.http.post(ServiceEndpointConstants.endpoints.INVOICE.NEWTIMESHEET, formdata).pipe(
            map((response: any) =>
            {
                return response.data;
            }),
            share());
    }

    public getAllTimeSheets(orgId: string, fromDate: string, toDate: string, timeSheetStatus: string, employeeId?: string): Observable<ITimeSheetResponse>
    {
        const config: IHttpRequestConfig = {
            params: {
                OrgId: orgId,
                ToDate: toDate,
                FromDate: fromDate,
                EmployeeId: employeeId,
                TimesheetStatus: timeSheetStatus
            }
        };
        return this.http.get(ServiceEndpointConstants.endpoints.INVOICE.GET_TIMESHEETS, null, config).pipe(
            map((response: any) =>
            {
                return {
                    timeSheets: InvoiceDelegate.normalizeTimeSheets(response.data.timeSheets ? response.data.timeSheets : [], response.data.lastTimeSheetSubmitDate),
                    success: response.data.success
                };
            }),
            share());
    }

    public getAllTimeSheetsByProjectId(projectCodeId: string): Observable<ITimeSheetResponse>
    {
        const config: IHttpRequestConfig = {
            params: {
                ProjectCodeId: projectCodeId
            }
        };
        return this.http.get(ServiceEndpointConstants.endpoints.INVOICE.GET_TIMESHEET_BY_PROJECT_ID, null, config).pipe(
            map((response: any) =>
            {
                return {
                    timeSheets: response.data.timeSheets,
                    lastTimeSheetSubmitDate: response.data.lastTimeSheetSubmitDate,
                    projectCodeId: projectCodeId,
                    success: response.data.success
                };
            }),
            share());
    }

    public getAllTimeSheetByTimeSheetId(timeSheetId: string): Observable<{ timeSheet: ITimesheetInternal; success: boolean }>
    {
        const config: IHttpRequestConfig = {
            params: {
                TimeSheetId: timeSheetId
            }
        };
        return this.http.get(ServiceEndpointConstants.endpoints.INVOICE.GET_TIMESHEET_BY_TIMESHEET_ID, null, config).pipe(
            map((response: any) =>
            {
                const normalized = InvoiceDelegate.normalizeTimeSheet(response.data.timeSheet);
                return {
                    timeSheet: TimesheetTransformer.toInternal(normalized),
                    success: response.data.success
                };
            }),
            share());
    }

    public getAllClientTimeSheetsByExternalEmail(externalEmailAddress: string): Observable<ITimeSheetResponse>
    {
        const config: IHttpRequestConfig = {
            params: {
                ExternalEmailAddress: externalEmailAddress
            }
        };
        return this.http.get(ServiceEndpointConstants.endpoints.INVOICE.GET_TIMESHEET_BY_EXTERNAL_EMAIL, null, config).pipe(
            map((response: any) =>
            {
                return {
                    timeSheets: InvoiceDelegate.normalizeTimeSheets(response.data.timeSheets ? response.data.timeSheets : []),
                    success: response.data.success
                };
            }),
            share());
    }

    public approveTimeSheets(timeSheets: ITimeSheetRequestData[], clientTimeStamp: string, userName: string, userId: string, orgId: string): Observable<ITimeSheetResponse>
    {
        const req = {

            TimeSheets: timeSheets,
            ClientTimeStamp: clientTimeStamp,
            UserName: userName,
            UserId: userId,
            OrgId: orgId
        };
        return this.http.post(ServiceEndpointConstants.endpoints.INVOICE.APPROVE_TIMESHEETS, req).pipe(
            map((response: any) =>
            {
                return {
                    timeSheets: InvoiceDelegate.normalizeTimeSheets(response.data.timeSheets ? response.data.timeSheets : []),
                    success: response.data.success
                };
            }),
            share());
    }

    public rejectTimeSheets(timeSheets: ITimeSheetRequestData[], clientTimeStamp: string, userName: string, userId: string, orgId: string): Observable<ITimeSheetResponse>
    {
        const req = {

            TimeSheets: timeSheets,
            ClientTimeStamp: clientTimeStamp,
            UserName: userName,
            UserId: userId,
            OrgId: orgId
        };
        return this.http.post(ServiceEndpointConstants.endpoints.INVOICE.REJECT_TIMESHEETS, req).pipe(
            map((response: any) =>
            {
                return {
                    timeSheets: InvoiceDelegate.normalizeTimeSheets(response.data.timeSheets ? response.data.timeSheets : []),
                    success: response.data.success
                };
            }),
            share());
    }

    public approveTimeSheet(timeSheetId: string, clientTimeStamp: string, userName: string, userId: string, comments: string): Observable<ITimeSheetResponse>
    {
        const req = {

            TimeSheetId: timeSheetId,
            Comments: comments,
            ClientTimeStamp: clientTimeStamp,
            UserName: userName,
            UserId: userId

        };
        return this.http.post(ServiceEndpointConstants.endpoints.INVOICE.APPROVE_TIMESHEET, req).pipe(
            map((response: any) =>
            {
                return {
                    timeSheets: InvoiceDelegate.normalizeTimeSheets(response.data.timeSheets ? response.data.timeSheets : []),
                    success: response.data.success
                };
            }),
            share());
    }

    public updateNewEmployeeTimeCard(newtimecard: ITimeCard): Observable<any>
    {

        const formdata = createFormData(newtimecard);

        return this.http.post(ServiceEndpointConstants.endpoints.INVOICE.UPDATE_TIMESHEET, formdata).pipe(
            map((response: any) =>
            {
                return response.data;

            }),
            share());
    }
    public rejectTimeSheet(timeSheetId: string, clientTimeStamp: string, userName: string, userId: string, comments: string): Observable<ITimeSheetResponse>
    {
        const req = {

            TimeSheetId: timeSheetId,
            Comments: comments,
            ClientTimeStamp: clientTimeStamp,
            UserName: userName,
            UserId: userId

        };
        return this.http.post(ServiceEndpointConstants.endpoints.INVOICE.REJECT_TIMESHEET, req).pipe(
            map((response: any) =>
            {
                return {
                    timeSheets: InvoiceDelegate.normalizeTimeSheets(response.data.timeSheets ? response.data.timeSheets : []),
                    success: response.data.success
                };
            }),
            share());
    }

    public getAllTimeSheetsByAccountManagerId(accountManagerId:string, year:number,timeSheetStatus: string): Observable<ITimeSheetResponse>{
        const config: IHttpRequestConfig = {
            params: {
                AccountManagerId:accountManagerId,
                Year:year,
                TimesheetStatus: timeSheetStatus
            }
        };
        return this.http.get(ServiceEndpointConstants.endpoints.INVOICE.GET_ALL_TIMESHEETS_BY_ACCOUNTMANAGER_ID, null, config).pipe(
            map((response: any) =>
            {
                return {
                    timeSheets: InvoiceDelegate.normalizeTimeSheets(response.data.timeSheets ? response.data.timeSheets : []),
                    success: response.data.success
                };
            }),
        share());
    }
    
    public static normalizeTimeSheets(timeSheets: any, lastTimeSheetSubmitDate?: any): ITimeSheet[]
    {
        return timeSheets.map(timeSheet =>
        {
            return this.normalizeTimeSheet(timeSheet);
        });
    }
    
    public static normalizeTimeSheet(timeSheet: any, lastTimeSheetSubmitDate?: any): ITimeSheet
    {
        
        timeSheet.lastTimeSheetSubmitDate = timeSheet && timeSheet.lastTimeSheetSubmitDate ? timeSheet.lastTimeSheetSubmitDate : lastTimeSheetSubmitDate;
        timeSheet.employeeFullName = timeSheet && timeSheet.projectCode && timeSheet.projectCode.employee ? timeSheet.projectCode.employee.employeeFullName : '';
        timeSheet.positionTitle = timeSheet && timeSheet.positionTitle ? timeSheet.projectCode.positionTitle : '';
        timeSheet.projectCode = timeSheet && timeSheet.projectCode ? timeSheet.projectCode.projectCode1 : '';
        timeSheet.approvedBy = timeSheet.approvedBy ? timeSheet.approvedBy : 'Pending To Approval';
        timeSheet.approvedDatetime = timeSheet.approvedDatetime ? timeSheet.approvedDatetime : '';
        timeSheet.selected = false;
        return timeSheet;

    }
}